<template>
  <div class="nft-sort-filter-comp">
    <div class="filter-button" @click="openSheet">
      <img src="@/assets/images/icons/sort.svg">
    </div>
    <bottom-slide-sheet
        v-model:visible="isOpen"
        title="listFilter.title"
    >
      <template #content>
        <div class="filter-area">
          <div class="filter-group mb-16">
            <div class="group-name">{{ $t('listFilter.sort') }}</div>
            <div
                v-for="(option, index) in sortOption"
                :key="index"
                class="filter-item"
                @click="selectSort(option.value)"
            >
              {{ $t(option.label) }}
              <img
                  v-show="selected.sort === option.value"
                  src="@/assets/images/icons/check.svg"
              >
            </div>
          </div>
          <div class="button-row">
            <MvButton
                text="common.apply"
                type="rec-primary"
                @click="applyFilter"
            />
          </div>
        </div>
      </template>
    </bottom-slide-sheet>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import BottomSlideSheet from '@/components/common/modal/BottomSlideSheet.vue';
import {useModal} from '@/script/common/modalScript';
import MvButton from '@/components/common/button/MvButton.vue';
import {
  useCltnListFilter,
  useNftFilter
} from '@/script/homeScript';
import {NftSortFilter} from '@/models/types';

export default defineComponent({
  name: 'NftSortFilterComp',
  components: {
    MvButton,
    BottomSlideSheet
  },
  setup() {
    const {
      toggleModal,
      isOpen,
    } = useModal()

    const {
      filters,
      changeSort,
    } = useCltnListFilter()

    const initConfig = () => {
      selected.sort = filters.value.sort
    }

    const openSheet = () => {
      initConfig()
      toggleModal(true)
    }

    const {
      sortOption,
      selected,
    } = useNftFilter()

    const selectSort = (value: NftSortFilter) => {
      selected.sort = value
    }

    const applyFilter = () => {
      if (selected.sort !== filters.value.sort) {
        changeSort(selected.sort)
      }
      toggleModal(false)
    }

    return {
      toggleModal,
      isOpen,
      sortOption,
      selected,
      selectSort,
      openSheet,
      applyFilter,
    }
  }
})
</script>
